import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import SportsTennisIcon from "@mui/icons-material/SportsTennis";
import { oraPrenotaStore } from "../oraPrenotaStore";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import StoreIcon from "@mui/icons-material/Store";
import { Collapse } from "@mui/material";
import { memo, useCallback, useState } from "react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import EuroIcon from "@mui/icons-material/Euro";
import PersonIcon from "@mui/icons-material/Person";
import { UserInfo } from "./UserInfo";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import KeyIcon from "@mui/icons-material/Key";
import GrassIcon from "@mui/icons-material/Grass";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import SettingsRemoteIcon from "@mui/icons-material/SettingsRemote";
import TocIcon from "@mui/icons-material/Toc";
import { prenotaStore } from "../prenotaStore";
import AlarmIcon from "@mui/icons-material/Alarm";
import MessageIcon from "@mui/icons-material/Message";
import { selectRole } from "../utils/selectors";
import { UserMsgSidebar } from "../messaggi/UserMsgSidebar";
import { MyLink } from "./MyLink";
import PaymentIcon from "@mui/icons-material/Payment";
import SettingsIcon from "@mui/icons-material/Settings";

export const Sidebar = memo(function Sidebar(props: { close?: () => void }) {
  const { close } = props;
  const role = oraPrenotaStore(selectRole);

  return (
    <Box sx={{ width: "100%", maxWidth: 280, bgcolor: "background.paper", overflowY: "auto" }}>
      <List component="nav" aria-label="main mailbox folders">
        {role === "ADMIN" && <AdminSidebar close={close} />}
        {role === "BACKOFFICE" && <BackofficeSidebar close={close} />}
        {role === "CLUB_ADMIN" && <ClubAdminSidebar close={close} />}
        {role === "USER" && <UserSidebar close={close} />}
      </List>
    </Box>
  );
});
const AdminSidebar = memo(function AdminSidebar(props: { close?: () => void }) {
  const { close } = props;

  return (
    <>
      <MyLink to="/app/createClub" text="Crea Club" close={close} icon={<AddBusinessIcon />} />
      <MyLink to="/app/clubs" text="Clubs" close={close} icon={<StoreIcon />} />
      <MyLink
        to="/app/tipologie"
        text="Tipologie Specifiche"
        close={close}
        icon={<SportsSoccerIcon />}
      />
      <MyLink
        to="/app/ricarica/metodiPagamento"
        text="Gestione Metodi Pagamento"
        close={close}
        icon={<PaymentIcon />}
      />
      <MyLink
        to="/app/ricarica/pagamentiSatispay"
        text="Pagamenti Satispay"
        close={close}
        icon={<PaymentIcon />}
      />
      <MyLink to="/app/specifica" text="Risorse Specifiche" close={close} icon={<GrassIcon />} />
      <MyLink to="/app/cambiaPassword" text="Cambio Password" close={close} icon={<KeyIcon />} />
    </>
  );
});
const BackofficeSidebar = memo(function BackofficeSidebar(props: { close?: () => void }) {
  const { close } = props;
  const setGiorno = prenotaStore((s) => s.setGiornoPrenotazione);
  const setOggiClick = useCallback(() => setGiorno(new Date()), [setGiorno]);

  return (
    <>
      <MyLink to="/app/users" text="Giocatori" close={close} icon={<PersonIcon />} />
      <MyLink
        to="/app/tabelloneTariffe/prenota"
        text="Prenotazioni"
        close={close}
        onClick={setOggiClick}
        icon={<SportsTennisIcon />}
      />
      <MyLink to="/app/cambiaPassword" text="Cambio Password" close={close} icon={<KeyIcon />} />
    </>
  );
});
const UserSidebar = memo(function UserSidebar(props: { close?: () => void }) {
  const { close } = props;

  return (
    <>
      <MyLink
        to="/app/tabelloneTariffe/prenota"
        text="Prenotazioni"
        close={close}
        icon={<SportsTennisIcon />}
      />
      <MyLink
        to="/app/visualizzazionePresenze"
        text="Dove e quando"
        close={close}
        icon={<SportsTennisIcon />}
      />
      <MyLink
        to="/app/gestionePrenotazioni"
        text="Le tue prenotazioni"
        close={close}
        icon={<SportsTennisIcon />}
      />
      <MyLink
        to="/app/gestionePrenotazioniAltri"
        text="Altre prenotazioni"
        close={close}
        icon={<SportsTennisIcon />}
      />
      <UserMsgSidebar close={close} />

      <MyLink to="/app/cambiaPassword" text="Cambio Password" close={close} icon={<KeyIcon />} />

      <Box marginLeft={3} marginTop={3}>
        <UserInfo />
      </Box>

      <MyLink to="/app/ricarica" text="Carica Credito" close={close} icon={<PaymentIcon />} />
    </>
  );
});
const ClubAdminSidebar = memo(function ClubAdminSidebar(props: { close?: () => void }) {
  const { close } = props;

  const [openTariffe, setOpenTariffe] = useState(false);
  const [openConti, setOpenConti] = useState(false);
  const setGiorno = prenotaStore((s) => s.setGiornoPrenotazione);
  const setOggiClick = useCallback(() => setGiorno(new Date()), [setGiorno]);

  return (
    <>
      <MyLink to="/app/createUser" text="Crea Giocatore" close={close} icon={<PersonIcon />} />
      <MyLink to="/app/users" text="Giocatori" close={close} icon={<PersonIcon />} />

      <MyLink to="/app/backOffice" text="Back Office" close={close} icon={<PersonIcon />} />

      <ListItemButton onClick={() => setOpenConti(!openConti)}>
        <ListItemIcon>
          <AccountBalanceWalletIcon />
        </ListItemIcon>
        <ListItemText primary="Conti" />
        {openConti ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={openConti} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <MyLink to="/app/conti" text="Conti" close={close} icon={<AccountBalanceWalletIcon />} />
          <MyLink
            to="/app/addTran"
            text="Aggiungi tran."
            close={close}
            icon={<AccountBalanceWalletIcon />}
          />
          <MyLink
            to="/app/causali"
            text="Causali"
            close={close}
            icon={<AccountBalanceWalletIcon />}
          />
        </List>
      </Collapse>

      <MyLink
        to="/app/gestioneRisorse"
        text="Gestione Risorse"
        close={close}
        icon={<SportsTennisIcon />}
      />

      <MyLink
        to="/app/tabelloneTariffe/prenota"
        text="Prenotazioni"
        close={close}
        onClick={setOggiClick}
        icon={<SportsTennisIcon />}
      />
      <MyLink
        to="/app/tabelloneTariffe/tariffe"
        text="Tariffe"
        close={close}
        onClick={setOggiClick}
        icon={<ShoppingCartIcon />}
      />

      <ListItemButton onClick={() => setOpenTariffe(!openTariffe)}>
        <ListItemIcon>
          <EuroIcon />
        </ListItemIcon>
        <ListItemText primary="Tariffe" />
        {openTariffe ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={openTariffe} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <MyLink
            to="/app/tipiAssociazioni"
            text="Tipologie Associazioni"
            close={close}
            icon={<EuroIcon />}
          />
          <MyLink to="/app/tipologieUso" text="Tipologie Uso" close={close} icon={<EuroIcon />} />
          <MyLink to="/app/tariffeDefinizioni" text="Tariffe" close={close} icon={<EuroIcon />} />
        </List>
      </Collapse>

      <MyLink
        to="/app/statistiche"
        text="Statistiche Prenotazioni"
        close={close}
        icon={<TocIcon />}
      />

      <MyLink
        to="/app/listaTransazioni"
        text="Lista Transazioni"
        close={close}
        icon={<TocIcon />}
      />

      <MyLink
        to="/app/ricarica/pagamentiSatispay"
        text="Pagamenti Satispay"
        close={close}
        icon={<PaymentIcon />}
      />

      <MyLink to="/app/domotica" text="Domotica" close={close} icon={<SettingsRemoteIcon />} />
      <MyLink to="/app/accensioni" text="Timers" close={close} icon={<AlarmIcon />} />

      <MyLink to="/app/messaggiAdmin" text="Comunicazioni" close={close} icon={<MessageIcon />} />
      <MyLink
        to="/app/impostazioniClub"
        text="Impostazioni"
        close={close}
        icon={<SettingsIcon />}
      />

      <MyLink to="/app/cambiaPassword" text="Cambio Password" close={close} icon={<KeyIcon />} />
    </>
  );
});
